import { defineStyle, defineStyleConfig } from '@chakra-ui/react'
import { textStyles } from '../foundations'

const baseStyle = defineStyle({
  color: 'text.heading',
})

const variantEyebrow = defineStyle(props => {
  const { size } = props

  return {
    ...textStyles[size],
    fontWeight: 'semibold',
    letterSpacing: 'allCaps',
    textTransform: 'uppercase',
  }
})

const variants = {
  eyebrow: variantEyebrow,
}

// For some reason, simply using "textStyle" doesn't work.
// Seems to be a known Chakra issue, so spread the
// options rather than use "textStyle"
const sizes = defineStyle({
  '2xs': defineStyle({
    ...textStyles['xs'],
  }),
  xs: defineStyle({
    ...textStyles['sm'],
  }),
  sm: defineStyle({
    ...textStyles['md'],
  }),
  md: defineStyle({
    ...textStyles['lg'],
  }),
  lg: defineStyle({
    ...textStyles['xl'],
  }),
  xl: defineStyle({
    ...textStyles['2xl'],
  }),
  '2xl': defineStyle({
    ...textStyles['3xl'],
  }),
  '3xl': defineStyle({
    ...textStyles['4xl'],
  }),
  '4xl': defineStyle({
    ...textStyles['5xl'],
  }),
})

export const Heading = defineStyleConfig({
  baseStyle,
  sizes,
  variants,
  defaultProps: {
    size: 'md',
  },
})
